import React from "react";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import DiagramaConversion, {
  AZUL_BIWO,
  AZUL_BIWO_BG,
  LIMA_BIWO,
  LIMA_BIWO_BG,
} from "./DiagramaConversion";

const AyudaEquivalencia = ({
  nombreBase,
  cantidadBase,
  nombrePresentacion,
  cantidadPresentacion,
}) => {
  const factor = parseFloat(cantidadBase);
  if (isNaN(factor) || factor <= 0) {
    return null;
  }

  const contenido = (
    <DiagramaConversion
      cajaA={{
        titulo: "Insumo base",
        cantidad: factor,
        unidad: nombreBase || "insumo",
        color: AZUL_BIWO,
        fondo: AZUL_BIWO_BG,
      }}
      cajaB={{
        titulo: "Se vende como",
        cantidad: cantidadPresentacion ?? 1,
        unidad: nombrePresentacion || "presentación",
        color: LIMA_BIWO,
        fondo: LIMA_BIWO_BG,
      }}
      factorTexto={
        <>
          Factor: <strong>{factor.toFixed(4)}</strong>
        </>
      }
    />
  );

  return (
    <Popover
      content={contenido}
      title="Cómo funciona esta equivalencia"
      trigger="hover"
      overlayInnerStyle={{ width: 312 }}
    >
      <QuestionCircleOutlined
        style={{ cursor: "pointer", color: "#8c8c8c", marginLeft: 4 }}
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
      />
    </Popover>
  );
};

export default AyudaEquivalencia;
